import { ReactElement } from 'react';

import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { resourceIcon } from '../../utils/resource-icons';
import { TreeViewItem, TreeViewProps } from '../../@types/tree-view-item';  
import OccurrenceActionsMenu from './menus/Occurrence.actions.menu';
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@mui/material';

const headers = [
    { id: 'uniqueId', label: 'Name' },
    { id: 'dateTime', label: 'DateTime' },
    { id: 'location', label: 'Location' },
    { id: 'group', label: 'Group' },
];
export function OccurrenceReportTable(props: TreeViewProps): ReactElement {
    const { title, nodes, onClickItem, exploreMode, order, orderBy, onRequestSort} = props;

    const handleSingleClick = (event: any): void => {
        if (exploreMode)
            onClickItem(event);
    }

    const handleDoubleClick = (event: any): void => {
        if (!exploreMode)
            onClickItem(event);
    }

    return (
        <>
            {title ? <Typography sx={{ mr: 1 }} variant='h6' color='primary'>{title}</Typography> : null}
            <TableContainer sx={{ mt: '20px', flexGrow: 1, overflowY: 'auto', width: '100%', overflowX: 'auto' }} >
                <Table size='small' stickyHeader aria-label="occurence reports table" >
                    <TableHead >
                        <TableRow>
                            {headers.map((header) => (
                                <TableCell key={header.id} align="left" sx={{ backgroundColor: 'rgb(226, 238, 250)' }} >
                                    <TableSortLabel
                                        active={orderBy === header.id}
                                        direction={orderBy === header.id ? order : 'asc'}
                                        onClick={(): void => onRequestSort?.(header.id)}
                                    >
                                        {header.label}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                            <TableCell align="right" sx={{backgroundColor: 'rgb(226, 238, 250)' }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ cursor: 'pointer' }}>
                        {nodes.map((node: TreeViewItem) => (
                            <TableRow key={node.type + '-' + node.id}
                                onClick={handleSingleClick}
                                onDoubleClick={handleDoubleClick}
                                hover
                            >
                                <TableCell id={'box-' + node.type + '-' + node.id}  align="left">
                                    <Stack direction="row" spacing={1}> 
                                        <Typography sx={{ mr: 1 }} component="div" >{resourceIcon(node.type)}</Typography>
                                        <Typography id={'box-' + node.type + '-' + node.id} variant="body2">{node.name}</Typography>
                                    </Stack>
                                </TableCell>
                                <TableCell align="center" id={'box-' + node.type + '-' + node.id + '-1'}  >
                                    <Typography variant="caption" id={'box-' + node.type + '-' + node.id + '-2'} >
                                        {new Date(node.dateTime!).toLocaleDateString()}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center" id={'box-' + node.type + '-' + node.id + '-2'}>
                                    <Typography variant="caption" id={'box-' + node.type + '-' + node.id + '-2'}>
                                        {node.location}
                                    </Typography>
                                </TableCell>
                                
                                <TableCell id={'box-' + node.type + '-' + node.id + '-3'}>
                                    <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end' }} id={'box-' + node.type + '-' + node.id + '-30'}>
                                        <Typography variant="caption" id={'box-' + node.type + '-' + node.id + '-31'} >
                                            {node.groupPath ? node.groupPath : null}
                                        </Typography>
                                        <Typography variant="caption" id={'box-' + node.type + '-' + node.id + '-32'} >
                                            {node.groupRole ? <Chip
                                                id={'box-' + node.type + '-' + node.id + '-320'} 
                                                label={node.groupRole.toUpperCase()}
                                                variant="outlined" size="small"
                                                sx={{ color: '#606060', fontSize: '8px' }}
                                            /> : null}
                                        </Typography>                                       
                                    </Stack>
                                </TableCell>
                                <TableCell align="right">
                                    <OccurrenceActionsMenu occurrence={node.object} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </TableContainer>
        </>
    );
}